import { render, staticRenderFns } from "./pie-chart.vue?vue&type=template&id=08838d2e&scoped=true"
import script from "./pie-chart.vue?vue&type=script&lang=js"
export * from "./pie-chart.vue?vue&type=script&lang=js"
import style0 from "./pie-chart.vue?vue&type=style&index=0&id=08838d2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08838d2e",
  null
  
)

/* custom blocks */
import block0 from "./pie-chart.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InfoAlert: require('/home/runner/work/frontpages/frontpages/component-library/src/components/molecules/alerts/info-alert.vue').default,HButton: require('/home/runner/work/frontpages/frontpages/component-library/src/components/atoms/buttons/h-button.vue').default,HLabel: require('/home/runner/work/frontpages/frontpages/component-library/src/components/atoms/forms/h-label.vue').default})
